import React from 'react'

import { Show } from '@app/components/util'
import { TopFilterItem } from '@app/components'
import { LntDatePicker, LntRangeDatePicker, LntSelect } from '@app/components/base'

import { dateFormat, SIZE } from '@app/constants'
import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { FILTERS_PLACEHOLDERS, PERIODS_VALUES } from '@app/constants/filters'

import { getFilterValue } from '@app/utils/filters'
import { weekSelectFormat } from '@app/utils/date/formats'
import { toDayjs, toDayjsByWeek } from '@app/utils/filters/adapters'

import { periodOptions } from './configs'

import styles from './styles.module.scss'

import type { FilterPeriodProps } from './types'

export const FilterPeriod: React.FC<FilterPeriodProps> = ({
  filters,
  isWeekSelected,
  selectedPeriodParam,
  onPeriodChange,
  onWeekChange,
  onRangeDateChange,
  atBeforeParamKey,
  atAfterParamKey
}) => {
  const atAfterFilterKey = atAfterParamKey ?? FILTERS_PARAMS_KEYS.createdAtAfter
  const atBeforeFilterKey = atBeforeParamKey ?? FILTERS_PARAMS_KEYS.createdAtBefore

  return (
    <TopFilterItem className={ styles.createdPeriod }>
      <LntSelect
        allowClear={ false }
        options={ periodOptions }
        value={ selectedPeriodParam ?? PERIODS_VALUES.date }
        onChange={ onPeriodChange }
        placeholder={ FILTERS_PLACEHOLDERS.periodFilter }
        size={ SIZE.middle }
        showArrow
      />

      <Show condition={ isWeekSelected }>
        <LntDatePicker
          picker='week'
          allowClear={ false }
          size={ SIZE.middle }
          placeholder={ FILTERS_PLACEHOLDERS.chosenWeek }
          value={ getFilterValue(filters, FILTERS_PARAMS_KEYS.week, toDayjsByWeek) }
          format={ weekSelectFormat }
          onChange={ onWeekChange }
        />
      </Show>

      <Show condition={ !isWeekSelected }>
        <LntRangeDatePicker
          allowClear={ false }
          size={ SIZE.middle }
          value={ [
            getFilterValue(filters, atAfterFilterKey, toDayjs),
            getFilterValue(filters, atBeforeFilterKey, toDayjs)
          ] }
          format={ dateFormat.DD_MM_YYYY }
          onChange={ onRangeDateChange }
        />
      </Show>
    </TopFilterItem>
  )
}
